
define('jst!shared/_provider',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<li class="g33" data-provider-name="<%= provider.get(\'name\') %>">\n  <div class="icon-32 icon-32-<%= provider.get(\'icon\') %> icon-32-<%= provider.get(\'icon\') %>-<%= capability %>"></div>\n  <span><%= provider.get(\'capability_names\')[capability] %></span>\n</li>\n');
 });

